import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-seo-cource-page-create",
  templateUrl: "./seo-cource-page-create.component.html",
  styleUrls: ["./seo-cource-page-create.component.scss"],
})
export class SeoCourcePageCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      // console.log(`${id}`);
      this.http
        .get<any>(this.api_endpoint + "/seocourcesbyid/" + `${id}`)
        .subscribe(
          (data) => {
            // console.log(data.data);
            if (data.data != null) {
              this.action = "Update";
              this.Form.patchValue({
                _id: data.data._id,
                slider: data.data.slider,
                sliderDescription: data.data.sliderDescription,
                url: data.data.url,
                description: data.data.description,
                metaTitle: data.data.metaTitle,
                metaKeyword: data.data.metaKeyword,
                metaDescription: data.data.metaDescription,
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    });

    this.Form = this.formBuilder.group({
      slider: ["", Validators.required],
      sliderDescription: [""],
      url: ["", Validators.required],
      description: ["", Validators.required],
      metaTitle: ["", Validators.required],
      metaKeyword: ["", Validators.required],
      metaDescription: ["", Validators.required],
      _id: [""],
    });
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      var data = {
        slider: this.Form.value.slider,
        sliderDescription: this.Form.value.sliderDescription,
        url: this.Form.value.url,
        description: this.Form.value.description,
        metaTitle: this.Form.value.metaTitle,
        metaKeyword: this.Form.value.metaKeyword,
        metaDescription: this.Form.value.metaDescription,
      };
      // console.log(data);
      this.http.post<any>(this.api_endpoint + "/seocources", data).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/seo-cource-page/list-page");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured." + err);
          }
        }
      );
    } else {
      var data1 = {
        slider: this.Form.value.slider,
        sliderDescription: this.Form.value.sliderDescription,
        url: this.Form.value.url,
        description: this.Form.value.description,
        metaTitle: this.Form.value.metaTitle,
        metaKeyword: this.Form.value.metaKeyword,
        metaDescription: this.Form.value.metaDescription,
        _id: this.Form.value._id,
      };
      // console.log(data1);
      this.http.put<any>(this.api_endpoint + "/seocources/", data1).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/seo-cource-page/list-page");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    }
  }
}
